<template>
  <div
    class="flex h-screen w-full flex-col bg-top bg-no-repeat bg-cover"
    :style="
      'background-image: url(' +
      require('@/assets/images/home/公司背景.png') +
      ');background-color:#fff'
    "
  >
    <header>
      <div class="shadow-lg grid grid-cols-2 gap-20 bg-white h-14">
        <div
          v-if="this.$route.path == '/products/glue'"
          class="flex-1 flex items-center p-3 pt-2 pb-2"
          @click="goHome"
        >
          <img src="@/assets/images/about/logo.png" />
          <img
            class="ml-4 mr-1 w-9"
            src="@/assets/images/products/COX_Label_02.png"
          />
          <img
            class="w-9 mr-1"
            src="@/assets/images/products/Mixpac_Label_Industry.png"
          />
          <img class="w-9" src="@/assets/images/products/MK_Label.png" />
        </div>

        <div v-else class="flex-1 flex items-center p-3" @click="goHome">
          <img src="@/assets/images/about/logo.png" />
        </div>
        <div class="flex-1 flex items-center grid justify-items-end pl-5">
          <top-menu @show="handleClick"></top-menu>
        </div>
      </div>
      <img src="@/assets/images/home/顶部彩色条.png" />
    </header>
    <section class="flex-1 overflow-auto relative">
      <div
        v-if="show"
        class="z-50 fixed overflow-auto translate-y-full ease-in duration-700 w-full  h-full	 inset-x-0  top-14 mt-1 left-0 bg-top bg-no-repeat bg-cover"
        :style="
          'background-image: url(' +
          require('@/assets/images/home/导航背景.png') +
          ');background-color:#fff'
        "
      >
        <ul
          class="list-inside list-none mx-16  align-baseline"
          v-for="(item, i) in list"
          :key="i"
        >
          <div
            class="h-12 flex items-center text-lg font-bold border-b border-gray-500"
          >
            {{ item.title }}
          </div>
          <li
            class=""
            v-for="(v, i) in item.children"
            :key="i"
            @click="onClick(v)"
          >
            <div
              class="flex items-center px-5 h-10 leading-10 text-base border-b border-gray-500"
            >
              <div class="flex-grow px-4 my-4">
                {{ v.title }}
              </div>
              <div class="flex-no-grow px-4 my-4">
                <svg
                  class="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <router-view> </router-view>
    </section>
    <footer
      class="text-white p-2 text-center flex-no-grow"
      style="
        font-family: HelveticaNeueLTStd !important;
        background-color: rgb(253, 167, 55);
      "
    >
      Delivering Innovation.Inspiring Confidence.
    </footer>
  </div>
</template>
<script>
export default {
  name: "app",
  components: {
    "top-menu": () => import("./views/menu.vue"),
  },
  data() {
    return {
      show: false,
      list: [
        {
          title: "公司",
          link: "/company",
          children: [
            {
              title: "关于迈德米斯",
              link: "/about",
            },
            {
              title: "新闻及活动",
              link: "",
            },
            {
              title: "联系我们",
              link: "/contact",
            },
          ],
        },
        {
          title: "产品",
          link: "/products",
          children: [
            {
              title: "胶枪",
              link: "/products/glue",
            },
            {
              title: "胶筒/混合管",
              link: "/products/industry",
            },
            {
              title: "应用",
              link: "/products/construction",
            },
          ],
        },
        {
          title: "行业应用",
          link: "/industry-application",
          children: [
            {
              title: "行业应用",
              link: "/industry-application",
            },
          ],
        },
        {
          title: "资源/服务中心",
          link: "/resource",
          children: [
            {
              title: "视频和直播",
              link: "/medias",
            },
            {
              title: "产品手册下载",
              link: "product-manual",
            },
          ],
        },
      ],
    };
  },
  methods: {
    handleClick() {
      this.show = !this.show;
    },
    goHome() {
      this.$router.push({
        path: "/",
      });
      this.show = false;
    },
    onClick(data) {
      if (data.title == "新闻及活动") {
        window.location.href =
          "http://mp.weixin.qq.com/mp/homepage?__biz=MzIyOTI2ODE3OA==&hid=1&sn=d6ee5592459d210ef9cecde42e57e8b8&scene=18#wechat_redirect";
        return;
      }
      if (!data.link) {
        return;
      }
      this.$router.push({
        path: data.link,
      });
      this.show = !this.show;
    },
  },
};
</script>
<style>
@font-face {
  font-family: HelveticaNeueLTStd;
  src: url("/static/fonts/HelveticaNeueLTStd-Lt.otf") format("opentype");
}
html,
body {
  font-family: HelveticaNeueLTStd !important;
  color:rgba(0,0,0,0.87)
}
</style>
